import * as React from 'react';
import {connect, ConnectedProps} from 'react-redux';

import {TextInputBox} from './TextInputBox';
import {changeText} from '../text_input_actions';
import {ConfigObjectType, StateId} from 'src/js/common/types';
import {RootState} from 'src/js/store';

interface OwnProps {
  config: ConfigObjectType;
  handleSubmit: () => void;
  stateId: StateId;
}

const mapState = (state: RootState, props: OwnProps) => ({
  isInvalidInput: state[props.stateId].isInvalidInput,
  submittingCounter: state[props.stateId].submittingCounter,
  text: state[props.stateId].text,
});

const mapDispatch = {
  changeTextAC: changeText,
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

const TextInputContainerComponent: React.FC<Props> = (props) => {
  const {
    stateId,
    changeTextAC,
    handleSubmit,
    config,
    isInvalidInput,
    submittingCounter,
    text,
  } = props;

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    changeTextAC(stateId, event.target.value);
  };

  const handleSubmitClick = (event: React.UIEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    handleSubmit();
  };

  return (
    <TextInputBox
      config={config}
      isInvalidInput={isInvalidInput}
      handleSubmitClick={handleSubmitClick}
      handleTextChange={handleTextChange}
      submittingCounter={submittingCounter}
      text={text}
    />
  );
};

TextInputContainerComponent.displayName = 'TextInputContainer';

export const TextInputContainer = connector(TextInputContainerComponent);
